import { render, staticRenderFns } from "./pageElementCroppedimage.vue?vue&type=template&id=dbc61ede&scoped=true&"
import script from "./pageElementCroppedimage.vue?vue&type=script&lang=js&"
export * from "./pageElementCroppedimage.vue?vue&type=script&lang=js&"
import style0 from "./pageElementCroppedimage.vue?vue&type=style&index=0&id=dbc61ede&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbc61ede",
  null
  
)

export default component.exports